import {Component, EventEmitter, Input, OnChanges, OnDestroy, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {PedidosProduzirService} from '../../services/pedidos-produzir.service';
import {AutorizacaoService} from '../../services/autorizacao.service';
import {DialogModule} from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-producao-pedido',
  standalone: true,
  imports: [CommonModule, FormsModule, DialogModule],
  templateUrl: './producao-pedido.component.html',
  styleUrls: ['../modal-comissionamento-pedido/modal-comissionamento-pedido.component.scss', './producao-pedido.component.scss']
})
export class ProducaoPedidoComponent implements OnChanges, OnDestroy {
  @Input() pedidoId: number;
  @Input() areaId: number;
  @Input() fila = false;
  @Input() integradoKds = false;
  @Input() moduloComissionamentoAtivo = false;
  @Input() labelComissionado = 'Comissionado';
  @Input() producaoAtiva = false;
  @Output() atualizado = new EventEmitter<void>();
  @Input() producoes: any[] = [];
  opcoes: any = {comissionados: [], areas: []};
  editando: any;
  erro = '';
  carregando = false;
  salvando = false;
  podeEditar = false;
  podeKds = false;
  private consulta = 0;

  constructor(private service: PedidosProduzirService, autorizacao: AutorizacaoService) {
    const usuario = autorizacao.getUser();
    const permissao = (id: number) => usuario && (usuario.admin || usuario.adminRede ||
      usuario.papeis?.some((p: any) => p.operacoes?.some((o: any) => Number(o.id) === id)));
    this.podeEditar = !!(usuario?.operador || permissao(4));
    this.podeKds = !!permissao(15);
  }

  ngOnChanges() {
    if(this.integradoKds) return;
    this.consulta++;
    this.producoes = [];
    this.editando = null;
    this.carregue();
  }

  async carregue() {
    if(this.integradoKds) return;
    if((!this.podeEditar && !this.podeKds) || (this.fila ? !this.areaId : !this.pedidoId)) return;
    const consulta = ++this.consulta;
    this.carregando = true;
    try {
      const producoes = await (this.fila ? this.service.listeProducoesDaArea(this.areaId) : this.service.listeProducoesDoPedido(this.pedidoId));
      if(consulta !== this.consulta) return;
      this.producoes = producoes.map((p: any) => ({...p,
        pedido: {...p.pedido, status: Number(p.pedido.status)}, fichas: JSON.parse(p.alternativas)}));
      this.erro = '';
    } catch(erro) {
      if(consulta === this.consulta) this.erro = String(erro?.message || erro);
    } finally { if(consulta === this.consulta) this.carregando = false; }
  }

  async edite(producao: any) {
    this.erro = '';
    this.editando = {...producao, atendimento: producao.atendimento || 'produzir', fichaId: producao.ficha?.id || null,
      comissionadoId: producao.comissionado?.id || null,
      prazo: producao.prazo};
    this.ajusteFichaAoMudarAtendimento();
    try { this.opcoes = await this.service.opcoesProducao(); }
    catch(erro) { this.erro = String(erro?.message || erro); }
  }

  producaoDoItem(idItem: number): any {
    return this.producoes.find(p => Number(p.itemPedido.id) === Number(idItem) && p.status !== 'cancelada');
  }

  fichasPermitidas(): any[] {
    return this.editando?.fichas.filter((f: any) => this.editando.atendimento !== 'vitrine' || f.tipo === 'produto-beneficiado') || [];
  }

  ajusteFichaAoMudarAtendimento() {
    const fichas = this.fichasPermitidas();
    if(fichas.length === 1) this.editando.fichaId = fichas[0].id;
    else if(!fichas.some((f: any) => f.id === this.editando.fichaId)) this.editando.fichaId = null;
  }

  fecheEdicao() {
    if(this.salvando) return;
    this.editando = null;
    this.erro = '';
  }

  valideSelecoes(): string {
    if(!['produzir', 'vitrine'].includes(this.editando?.atendimento)) return 'Selecione o atendimento.';
    if(this.fila && !this.fichasPermitidas().some(f => Number(f.id) === Number(this.editando.fichaId)))
      return 'Selecione uma ficha / receita.';
    if(!this.fila && this.editando.atendimento === 'produzir' && this.moduloComissionamentoAtivo &&
      !this.opcoes.comissionados.some((p: any) => Number(p.id) === Number(this.editando.comissionadoId)))
      return `Selecione ${this.labelComissionado.toLowerCase()}.`;
    return '';
  }

  async salve(iniciar = false) {
    if(this.salvando) return;
    this.erro = this.valideSelecoes();
    if(this.erro) return;
    const p = this.editando;
    this.salvando = true;
    this.erro = '';
    try {
      await this.service.salveProducao(p.id, {versao: p.versao, atendimento: p.atendimento,
        ficha: p.fichaId ? {id: p.fichaId} : null, comissionado: p.atendimento === 'produzir' && p.comissionadoId ? {id: p.comissionadoId} : null,
        areaDestino: p.atendimento === 'produzir' ? p.areaDestino || null : null,
        prazo: p.prazo || null, iniciar});
      this.editando = null;
      await this.carregue();
      this.atualizado.emit();
    } catch(erro) { this.erro = String(erro?.message || erro); }
    finally { this.salvando = false; }
  }

  ngOnDestroy() { this.consulta++; }
}
